import { useState } from "react";
import LegalPageLayout from "../components/LegalPageLayout";

function CookiePreferences() {

    const [cleared, setCleared] = useState(false);

    const handleClearLocalData = () => {

        const ok = window.confirm(
            "This will log you out and reset your saved preferences (like your chosen theme) on this device. Continue?"
        );

        if (!ok) return;

        localStorage.clear();

        setCleared(true);

        setTimeout(() => {
            window.location.href = "/";
        }, 1200);

    };

    return (

        <LegalPageLayout title="Cookie & Local Storage Preferences">

            <p className="legal-effective-date">Last updated: 2026</p>

            <p>
                This portal does <strong>not</strong> use tracking, advertising, or third-party
                analytics cookies. There is nothing here to opt in or out of in that sense - we
                simply don't set that kind of cookie.
            </p>

            <h2>What we actually store, and why</h2>
            <p>
                What this portal does use is your browser's <strong>local storage</strong> (a
                different mechanism from cookies, and not shared with any third party) to:
            </p>

            <ul>
                <li>Keep you logged in between page loads, without asking for your password again on every navigation.</li>
                <li>Remember your role's effective menu permissions, so the sidebar reflects what you can actually access.</li>
                <li>Remember personal display preferences, such as your chosen Theme Settings color.</li>
            </ul>

            <p>
                None of this data leaves your device except your login token itself, which is sent
                back to our own servers (never a third party) to authenticate each request you make.
            </p>

            <h2>Clearing your data</h2>
            <p>
                You can clear everything this portal has stored in your browser at any time. This
                will log you out and reset preferences (like your theme) back to default on this
                device - it does not delete your account or any data stored on our servers.
            </p>

            <button
                type="button"
                className="add-btn"
                onClick={handleClearLocalData}
                disabled={cleared}
            >
                {cleared ? "Cleared - redirecting..." : "Clear my local data on this device"}
            </button>

        </LegalPageLayout>

    );

}

export default CookiePreferences;
